import { george, observer, pr, React, theme, ui } from "aaa";
import * as i18n from "i18n/util";
import { inject } from "mobx-react";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { MessageLabelContainer, MessageScreenText } from "../../util/primitives";
import PinResetStore from "../stores/PinResetStore";

interface IProps {
    pinResetStore: PinResetStore;
    externalInterfaceStore: ExternalInterfaceStore;
}

function injectSpaces(s: string): string {
    return s.replace(/(.{1})/g, "$1 ").slice(0, -1);
}

/**
 * Component for rendering captcha image after successful signing
 */
@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class PinSuccess extends React.Component<IProps & i18n.InjectedIntlProps, {}> {
    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.style.backgroundColor = theme.headerBackgroundColor(ui.isDarkMode);
    }

    componentWillUnmount() {
        document.body.style.backgroundColor = "";
    }

    render() {
        let pin = "XXXX";
        let product = "-";
        if (this.props.pinResetStore.signingResponse
            && this.props.pinResetStore.pin
        ) {
            pin = this.props.pinResetStore.pin.pin.encryptedPin;
            product = this.props.pinResetStore.getProductString();
        }

        return (
            <pr.VFlex>
                <george.MessageScreenBackground>
                    <div style={{ textAlign: "center" }}>

                        <MessageLabelContainer>
                            <pr.H1WithFocus style={{ ...pr.styleNoPadding, color: "white", fontSize: 24, fontWeight: 600 }}>
                                <i18n.FormattedMessage
                                    id="pin.order.success.title"
                                    values={{
                                        product: product
                                    }}
                                />
                            </pr.H1WithFocus>
                        </MessageLabelContainer>
                        <br /><br />

                        {/* Render the pin */}
                        {
                            <span
                                style={{
                                    fontSize: 48,
                                    borderRadius: "4px",
                                    border: "4px solid #ffffff",
                                    fontFamily: "Inter Light",
                                    color: "white",
                                    fontWeight: "bold",
                                    paddingLeft: 15,
                                    paddingRight: 15,
                                    letterSpacing: -2
                                }}
                            >
                                {injectSpaces(pin)}
                            </span>
                        }

                        <br /><br /><br /><br />
                        <MessageLabelContainer>
                            <MessageScreenText>
                                <i18n.FormattedMessage id="pin.order.success.message" />
                            </MessageScreenText>
                        </MessageLabelContainer>
                    </div>

                    {externalInterfaceStore.isGeorgeApp &&
                        <george.SuccessButton
                            label={ui.__("pin.order.success.closebutton.title")}
                            onClick={() => this.props.externalInterfaceStore.raiseExitSuccess("pinReset")}
                        />
                    }
                </george.MessageScreenBackground >
            </pr.VFlex>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pin/views/PinSuccess.tsx